import { DatePipe } from '@angular/common';
import { Component, EventEmitter, HostListener, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { ISubscription } from "rxjs/Subscription";
import { environment } from '../../../shared/config/app-config';
import { CallService, JwtService, PatientService, ScrollToBottomDirective, User, UserService } from '../../../shared';
declare function downloadImg(): any;
declare function showMarkerArea(): any;

@Component({
  selector: 'app-singlelist',
  templateUrl: './singlelist.component.html',
  styleUrls: ['./singlelist.component.css', '../messagehosp.component.css']
})
export class SinglelistComponent implements OnInit {
  CurrentUser: User;
  uploadfile: any;
  messagesread: any;
  @ViewChild(ScrollToBottomDirective)
  scroll: ScrollToBottomDirective;
  @Input() msginfo: any;
  @Input() msgload: any;
  @Input() patswfid: any;
  @Input() pswActive: any;
  @Output() submitmsg = new EventEmitter<any>();
  public msg: any = { message: '' };
  apiurl: any = environment.api_url;
  public timealert = environment.timelimit;
  public dateform = environment.dateForm;
  public params: any;
  public dateformat = {
    date: {
      pipe: 'dd/MM/yyyy'
    }
  };
  subscription: ISubscription;
  public imageURL: string = environment.cloudeImageURL;
  croppedImage: string;
  cropperReady: boolean;
  imageChangedEvent: any; imgMaxSize: any;
  modalRef: BsModalRef;
  upimage: any;
  ;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private patientService: PatientService,
    private toast: ToastrService,
    private jwtService: JwtService,
    private Datepipe: DatePipe,
    private modalService: BsModalService,
    private callService: CallService

  ) {

    this.subscription = callService.messagescomponentMethodCalled$.subscribe(
      () => {
        //this.temp_var = false;
        this.ngOnInit()
      }
    );
  }


  ngOnDestroy() {
    // alert("Destroy Calling Here");
    if (!!this.subscription) {
      this.subscription.unsubscribe();
    }

  }


  ngOnInit() {
    // this.unread();
    this.userService.currentUser.subscribe(
      (userData) => {
        this.CurrentUser = userData;
        if (this.CurrentUser.item) {
          if (this.CurrentUser.item.hostModel == "CLOUD")
            this.imageURL = environment.cloudeImageURL;
          else
            this.imageURL = environment.vmImageURL;
        } else
          this.imageURL = environment.vmImageURL;
      }
    )


    // this.userService.getmessages(window.localStorage['Puser'])
    // if (this.msginfo)
    //   this.selectmessage(this.msginfo)

  }



  selectmessage(msginfo) {
    let mode = 'C'
    this.patientService.getccmessagesinfo(msginfo.patientSwfId, mode)
      .subscribe(
        data => {
          if (data) {
            this.msginfo = data;
            this.patswfid = msginfo.patientSwfId
            this.getmsgcount()
          }
        }

      );
  }
  submitmsgs(msg) {

    let msgobj = {
      ccUserAccountId: this.CurrentUser.item.userAccountId,
      description: msg.value.message,
      patientSwfId: this.patswfid,
      pswIsActive: this.pswActive
    }

    this.submitmsg.emit(msgobj)
    msg.resetForm()
  }
  getdate(date) {
    date = date.split(' ')
    return date[0]
  }
  getdatetime(date) {
    date = new Date(date)
    if (this.CurrentUser.item.dateFormat.toLowerCase() == 'mmddyyyy') {
      return this.Datepipe.transform(date, 'MM/dd/yyyy hh:mm a');
    } else if (this.CurrentUser.item.dateFormat.toLowerCase() == 'ddmmyyyy') {
      return this.Datepipe.transform(date, 'dd/MM/yyyy hh:mm a');
    }
  }
  gettime(date) {
    date = date.split(' ')
    if (date.length > 3)
      return date[1] + ' ' + date[2] + ' ' + date[3]
    else
      return date[1] + ' ' + date[2]
  }
  getmsgcount() {
    if (window.localStorage['startdate'] && window.localStorage['enddate']) {
      this.patientService.countrange(this.CurrentUser.item.userAccountId, window.localStorage['startdate'], window.localStorage['enddate'])
        .subscribe(
          data => {
            this.CurrentUser.item.msgcount = data.messageCount;
          }
        );
    } else {
      this.patientService.countrange(this.CurrentUser.item.userAccountId, 'N', 'N')
        .subscribe(
          data => {
            this.CurrentUser.item.msgcount = data.messageCount;
          })
    }
  }
  document(template: TemplateRef<any>) {
    this.croppedImage = '';
    this.modalRef = this.modalService.show(template, {
      class: 'modal-lg wide',
      backdrop: 'static'
    })
    showMarkerArea();
  }
  fileChangeEvent(event: any, template: TemplateRef<any>): void {
    this.croppedImage = '';
    this.imageChangedEvent = event;
    if (event.target.files.length > 0) {
      this.upimage = event.target.files[0];
      var reader = new FileReader();
      reader.readAsDataURL(this.upimage);
      reader.onload = (_event) => {
        this.upimage = reader.result;
      }


      //console.log(this.rc_image)
    }
    let acceptFormat = ['image/png', 'image/x-png', 'image/jpeg', 'image/jpg']
    //console.log(this.imageChangedEvent.srcElement);
    if (!acceptFormat.includes(this.imageChangedEvent.srcElement.files[0].type)) {
      this.toast.error(this.userService.translateText('patient_portal.validations.file_not_allowed.error_label'), '', {
        timeOut: this.timealert
      })
      this.imageChangedEvent = "";
      // this.croppedImage = this.defaultUl;
      return;
    } else if (this.imageChangedEvent.srcElement.files[0].size > this.imgMaxSize) {
      this.toast.error(this.userService.translateText('patient_portal.validations.maximum_size_exceed.error_label'), '', {
        timeOut: this.timealert
      })
      this.imageChangedEvent = "";
      // this.croppedImage = this.defaultUl;
      return;
    }
    // this.uploadfile='';
    // //console.log(this.imageChangedEvent.srcElement.files[0].name);
  }
  imageCropped(image: string) {
    this.croppedImage = image;

    // //console.log(this.croppedImage);
  }
  imageLoaded(event) {


    this.cropperReady = true;
  }
  imageLoadFailed() {
    //console.log('Load failed');
  }
  public pad: any = {

  };
  clearall() {
    this.imageChangedEvent = '';
    this.croppedImage = '';
    this.pad.note = '';
    this.upimage = ''
    window.localStorage.removeItem('imgEditor')
  }
  postdoc() {
    // console.log("img path", this.imageChangedEvent)
    //this.upimage = window.localStorage['imgEditor']
    if (this.upimage != undefined) {
      // //console.log("in", this.title, this.note);
      let datapost = {
        "postimg": {
          "description": '',
          "attachmentPath": "",
          "attachmentType": 'png',
          "ccUserAccountId": this.CurrentUser.item.userAccountId,
          "patientSwfId": parseInt(this.patswfid),
          "title": "Message",
          "attachment": {
            "filename": 'Download',
            "filetype": 'png',
            "value": this.upimage.split(',')[1]

          }
        },
        "portal": 'cc',
        "patientSwfId": parseInt(this.patswfid),
        'pswIsActive': this.pswActive
      };
      // console.log(datapost)
      this.submitmsg.emit(datapost)
      this.clearall();
      //this.modalRef.hide()
    }


  }
  @HostListener('document:click', ['$event'])
  pop_up_over(event) {
    // Get the modal
    //  console.log(event)
    if (event.target.className == 'tui-image-editor-download-btn') {
      this.upimage = downloadImg()
      var aa = $('input.tui-image-editor-load-btn').val();
      if (aa != '') {
        setTimeout(() => {
          this.postdoc();
          this.modalRef.hide()
        }, 20);
      }
    }

    /* if (event.target.localName == 'svg'){
     $('.__markerjs2_ svg').attr('id','cimg');
      var x = document.getElementById("cimg");
      x.addEventListener("click", imagecropevent);
    }*/
    if (event.target.localName == 'img' && event.target.id && event.target.id != 'croppimg') {
      var modal = document.getElementById("myModal");
      modal.style.display = "block";
      // Get the image and insert it inside the modal - use its "alt" text as a caption
      var img = document.getElementById(event.target.id) as any as HTMLImageElement;
      var modalImg = document.getElementById("img01") as any as HTMLImageElement;
      var captionText = document.getElementById("caption") as any as HTMLImageElement;
      modalImg.src = img.src;
      captionText.innerHTML = img.alt;
      // Get the <span> element that closes the modal
      //var span = document.getElementsByClassName("close")[0];
    }

  }
  close_pop() {
    var modal = document.getElementById("myModal");
    modal.style.display = "none";
  }
}